module.exports = __webpack_public_path__ + "img/consumption_blue.841a1384.png";